import { CopyOutlined, DeleteOutlined, FormOutlined } from '@ant-design/icons';
import { Col, Popconfirm, Row, Tooltip } from 'antd';
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { AnyAction } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { AppState } from '../../types/AppState';
import { copyPathway, deletePathway, setCurrentPathway } from './actions';
import { findPathway } from './reducers';
import { CohortPathway } from './types/CohortPathway';

interface Props {
    pathway: CohortPathway,
    pathways: CohortPathway[],
    setCurrentPathway(pathwayId: number): void;
    copyPathway(pathwayId: number): void;
    deletePathway(pathwayId: number): void;
}

const SavedPathwaysList = ({ pathway, pathways, setCurrentPathway, copyPathway, deletePathway }: Props) => {

    const getDate = (pathway: CohortPathway) => {
        if (!_.isNil(pathway.createdOn)) {
            const timestamp = pathway.createdOn
            const date = new Date(timestamp)

            var timeOptions = { hour: '2-digit', minute: '2-digit' }
            const timeString = date.toLocaleTimeString('en-GB', timeOptions)

            var dateOptions = { year: 'numeric', month: 'long', day: 'numeric' }
            const dateString = date.toLocaleDateString('en-GB', dateOptions)
            return `${dateString}, ${timeString}`
        } else {
            return null
        }
    }

    const editFunctionality = (p: CohortPathway) => {
        return [
            <Tooltip key="1" title="copy pathway">
                <CopyOutlined onClick={e => { e.stopPropagation(); copyPathway(p.id) }} />
            </Tooltip>,
            <span key="2" onClick={(e) => e.stopPropagation()}>
                <Popconfirm
                    title="Are you sure you want to delete this?"
                    onConfirm={() => { deletePathway(p.id) }}
                    okText="Yes"
                    cancelText="No">
                    <Tooltip title="delete pathway">
                        <DeleteOutlined onClick={e => { e.stopPropagation(); }} />
                    </Tooltip>
                </Popconfirm>
            </span>
        ];
    }

    const getStatus = (pathway: CohortPathway) => {
        if (pathway.id <= 0) {
            return <Tooltip title="pathway is unsaved"><FormOutlined /></Tooltip>
        }
        return null
    }

    const contentForListOfPathways = () => {
        return pathways.map(p =>
            <Row key={p.id} className={"query " + (pathway.id === p.id ? "active" : "")} onClick={() => setCurrentPathway(p.id)}>
                <Col span={24}><span className="title">{p.title}</span> {getStatus(p)}</Col>
                <Col span={24} className="date">{getDate(p)}</Col>
                <Col span={24}>
                    <Row className="actions-bar" >
                        <Col span={12} className="justify-left">{editFunctionality(p)} </Col>
                    </Row>
                </Col>
            </Row >
        )
    }

    return (
        <Row className="pathways-list">
            <Col span={24}>
                <Row className="queries-title">
                    <Col span={12} className="justify-left">My Pathways</Col>
                </Row>
                {contentForListOfPathways()}
            </Col>
        </Row>
    )
}

const mapStateToProps = (state: AppState, ownProps: any) => {
    const pathway = findPathway(state.pathway.pathways, state.pathway.pathwayId!)
    return {
        pathway: pathway,
        pathways: state.pathway.pathways,
        ...ownProps
    }
}

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
    return {
        setCurrentPathway: (pathwayId: number) => {
            dispatch(setCurrentPathway(pathwayId))
        },
        copyPathway: (pathwayId: number) => {
            dispatch(copyPathway(pathwayId))
        },
        deletePathway: (pathwayId: number) => {
            dispatch(deletePathway(pathwayId))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SavedPathwaysList)